import React, { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PasswordErrorMsg from "components/PasswordErrorMsg";
import TextInput from "components/FormElements/TextInput";
import AlertModal from "components/AlertModal";
import SignInLogo from "assets/svg/Logo";
import EmailFieldInput from "components/FormElements/EmailFieldInput";
import SuccessMsg from "components/SuccessMsg";
import KeyIcon from "assets/svg/ForgetPasswordKeyIcon";
import PasswordIconText from "assets/svg/PasswordIconText";
import EndIcon from "assets/svg/PasswordShowIcon";
import { changePassword } from "redux/actions/changePassword";

import {
  getAuthInitialValues,
  VALIDATION_SCHEMA,
} from "utils/resetPasswordUtils";

import Button from "components/Button";
import LeftContainer from "components/LeftContainer";
import { Heading } from "styles/pages/login";
import {
  BodyContainer,
  RegistrationContainer,
  FormContainer,
  InputField,
  Footer,
  Container,
  RightContainer,
  LogoWrapper,
} from "styles/pages/global";
import { useText } from "locales/useGetText";
const ResetPassword = () => {
  const locale = useText("resetPassword");
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    if (!params.get("token")) {
      navigate("/");
    }
  }, []);

  let formObj = {
    email: params.get("email"),
    token: params.get("token"),
  };

  const [successState, setSuccessState] = useState(false);
  const [response, setResponse] = useState({
    paload: "",
    buttonName: "OK",
    navigationLink: "/",
    heading: "",
    description: "",
  });

  const formSubmit = async (props) => {
    const { submitForm, validateForm, setTouched, isValid } = props;
    submitForm().then(async () => {
      if (isValid) {
        let data = {
          password: props?.values.password,
          confirmPassword: props?.values.confirmPassword,
          email: params.get("email"),
          token: params.get("token"),
        };
        const response = await dispatch(changePassword(data));
        if (response?.data?.success) {
          setSuccessState(true);
          setResponse({
            ...response,
            paload: "",
            buttonName: locale("login"),
            navigationLink: "/",
            heading: locale("congratulations"),
            description: locale("passwordSetupSuccess"),
          });
        } else {
          setSuccessState(false);
          setModalContent(response?.data?.error?.message);
          setModalLink("");
          toggleModal();
        }

        window.scrollTo(0, 0);
        validateForm();
        setTouched({});
      }
    });
  };

  const [allErrors, setAllErrors] = useState([]);
  const [passwordVal, setPasswordVal] = useState([]);

const checkForAllErrors = async (value) => {
  try {
    await VALIDATION_SCHEMA(locale).validate(
      { password: value },
      { abortEarly: false }
    );
    setAllErrors([]);
  } catch (ex) {
    setAllErrors(ex.errors || []);
  }
};

  const formFields = () => {
    return (
      <Container>
        <LeftContainer />
        <RightContainer className="setup-password">
          <RegistrationContainer>
            <LogoWrapper className="for-forget-password">
              <SignInLogo />
            </LogoWrapper>
            {!successState ? (
              <>
                <KeyIcon className="key-icon" />

                <Formik
                  initialValues={getAuthInitialValues(formObj)}
                  validationSchema={VALIDATION_SCHEMA(locale)}
                  onSubmit={() => {}}
                >
                  {(props) => {
                    const { isValid, dirty } = props;
                    return (
                      <Form className="setup-password">
                        <FormContainer>
                          <Heading>{locale("setNewPassword")}</Heading>

                          <InputField data-testid="Email">
                            <EmailFieldInput
                              name="email"
                              placeholder={locale("emailLabel")}
                              disabled={true}
                              maxLength={100}
                              showErrorMessages={true}
                            />
                          </InputField>

                          <InputField>
                            <div data-testid="New Password">
                              <TextInput
                                name="password"
                                type={showPassword ? "text" : "password"}
                                inputType="password"
                                placeholder={locale("newPassword")}
                                maxLength="20"
                                onChangeHandler={(text, val) => {
                                  setPasswordVal(val);
                                  checkForAllErrors(val);
                                }}
                              />
                            </div>

                            {!showPassword ? (
                              <EndIcon
                                className="passwordIcon"
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                              />
                            ) : (
                              <PasswordIconText
                                className="passwordIcon"
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                              />
                            )}
                          </InputField>

                          <InputField>
                            <div data-testid="Confirm Password">
                              <TextInput
                                name="confirmPassword"
                                maxLength="20"
                                inputType="password"
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder={locale("confirmPassword")}
                              />
                            </div>
                            {!showConfirmPassword ? (
                              <EndIcon
                                className="passwordIcon"
                                onClick={() => {
                                  setShowConfirmPassword(!showConfirmPassword);
                                }}
                              />
                            ) : (
                              <PasswordIconText
                                className="passwordIcon"
                                onClick={() => {
                                  setShowConfirmPassword(!showConfirmPassword);
                                }}
                              />
                            )}
                          </InputField>
                          <div>
                            <PasswordErrorMsg
                              error={allErrors}
                              value={passwordVal}
                              locale={locale}
                            />
                          </div>
                          <Footer>
                            <Button
                              disabled={!(isValid && dirty)}
                              handleClick={() => formSubmit(props)}
                            >
                              {locale("setupPassword")}
                            </Button>
                          </Footer>
                        </FormContainer>
                      </Form>
                    );
                  }}
                </Formik>
              </>
            ) : (
              <>
                <SuccessMsg response={response} icon={KeyIcon} locale={locale}/>
              </>
            )}

            <AlertModal
              isOpen={modal}
              toggle={toggleModal}
              title={locale("alert")}
              content={modalContent}
              link={modalLink}
              className="alert-msg-container"
              InnerClassName="alert-msg"
            />
          </RegistrationContainer>
        </RightContainer>
      </Container>
    );
  };

  return <BodyContainer>{formFields()}</BodyContainer>;
};

export default ResetPassword;
